import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import type { Condition } from '../../../../../../common/types';
import { ConditionHeader } from '../../../../../../common/ui/conditions/condition-header';
import { RowView, RowEmpty } from '../../../../../../common/ui/conditions/styled';
import messages from './messages';

type Props = {
	listName: string;
	selectedConditions: Condition[];
};

export const ConditionViewComponent = ({ listName, selectedConditions }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<>
			<ConditionHeader listName={listName} />
			<Box xcss={conditionListContainerStyles}>
				{selectedConditions.length ? (
					selectedConditions.map((condition) => {
						const { conditionId, name } = condition;
						return (
							<RowView
								key={`${listName}-condition-${conditionId}`}
								data-test-id={`servicedesk-sla-settings.ui.metrics.metric.metric-view.conditions.condition.condition-view-${listName}-${conditionId}`}
							>
								{name}
							</RowView>
						);
					})
				) : (
					<RowEmpty>{formatMessage(messages.noConditions)}</RowEmpty>
				)}
			</Box>
		</>
	);
};

export const ConditionView = ConditionViewComponent;

const conditionListContainerStyles = xcss({
	marginBottom: 'space.300',
});
